import ConsumptionChart from "./ConsumptionChart";
import CounterTableHeader from "./CounterTableHeader";
import useCustomState from "../../hooks/State";
import EventTable from "./EventTable";
import OrdersShow from "./OrdersShow";
import MqttClient from "../MQTT";
import CounterRecords from "./CounterRecords";
// import Orders from "./Orders";
// import useCustomState from "../../hooks/State";
// import ListBuyers from "./ListBuyers";
// import ListCounterTypes from "./ListCounterTypes";
import ConsumptionsTable from "./ConsumptionTable";

const Details = (props) => {
  const projectId = props.data.match.params.pId;
  const userId = props.data.match.params.userId;
  const categoryId = props.data.match.params.categoryId;
  const counterSerial = props.data.match.params.counterSerial;
  // const image = projectId % 2 === 0 ? ProjectImg : ProjectImg2;

  const counterInfo = useCustomState({});
  return (
    <div
      style={{
        paddingLeft: "16px",
        paddingRight: "16px",
        paddingTop: "24px",
      }}
    >
      <div style={{ marginBottom: "24px" }}>
        <CounterTableHeader
          projectId={projectId}
          serial={counterSerial}
          counterInfo={counterInfo}
        />
      </div>
      <div className="cons-chart" style={{ marginBottom: "24px" }}>
        <ConsumptionChart
          counterInfo={counterInfo.value}
          serial={counterSerial}
        />
      </div>
      <div style={{ marginBottom: "24px" }}>
        <ConsumptionsTable serial={counterSerial} />
        {/* <CounterRecords serial={counterSerial.value} /> */}
      </div>
      <div style={{ marginBottom: "24px" }}>
        <EventTable serial={counterSerial} />
      </div>
      <div style={{ marginBottom: "24px" }}>
        <OrdersShow serial={counterSerial} />
      </div>

      <MqttClient projectId={projectId} />
    </div>
  );
};

export default Details;
